// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slickgrid/dist/styles/css/slick.columnpicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slickgrid/dist/styles/css/slick-alpine-theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Log Viewer Component Styles */

.log-viewer-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.log-viewer-panel {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    z-index: 1001;
}

.log-viewer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #e0e0e0;
    background: #f5f5f5;
    gap: 12px;
}

.log-viewer-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.tail-status,
.tail-timer,
.log-count {
    font-size: 12px;
    color: #666;
    padding: 4px 8px;
    background: #e8f5e9;
    border-radius: 3px;
}

.tail-timer {
    background: #fff3e0;
    color: #f57c00;
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
}

.log-count {
    background: #e3f2fd;
    color: #1976d2;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
}

.log-viewer-body {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.log-viewer-sidebar {
    width: 280px;
    border-right: 1px solid #e0e0e0;
    overflow-y: auto;
    padding: 12px;
    background: #fafafa;
}

.sidebar-section {
    margin-bottom: 20px;
}

.section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.section-actions {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.link-btn {
    background: none;
    border: none;
    color: #1976d2;
    cursor: pointer;
    font-size: 12px;
    padding: 2px 4px;
    border-radius: 2px;
}

.link-btn:hover {
    background: #e3f2fd;
}

#service-refresh-btn {
    font-size: 18px;
    line-height: 1;
    font-weight: 700;
    padding: 2px 6px;
}

/* Service Selection */
.service-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.service-search-input {
    width: 100%;
    box-sizing: border-box;
    padding: 6px 8px;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    font-size: 12px;
    margin-bottom: 6px;
}

.service-search-input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.service-token-pills,
.service-token-suggestions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 6px;
}

.service-token-pills.hidden,
.service-token-suggestions.hidden {
    display: none;
}

.service-token-pill,
.service-token-suggestion {
    border: 1px solid #bfd4ea;
    background: #eef6ff;
    color: #17456a;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    padding: 6px 10px;
    cursor: pointer;
}

.service-token-suggestion:hover,
.service-token-pill:hover {
    background: #e0eefc;
}

.service-token-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #dfeeff;
}

.service-token-pill-remove {
    font-size: 12px;
    font-weight: 700;
}

.service-item {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 6px 10px;
    background: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    color: #333;
    text-align: left;
    font-family: inherit;
    transition: background 0.15s, border-color 0.15s;
}

.service-item:hover {
    background: #f0f4f8;
    border-color: #aac4d8;
}

.service-item.selected {
    background: #dfeeff;
    border-color: #6aaad8;
    color: #0b4e7a;
    font-weight: 600;
}

.service-list-empty {
    font-size: 12px;
    color: #777;
    background: #fff;
    border: 1px dashed #d5d5d5;
    border-radius: 3px;
    padding: 8px;
}

.service-count {
    font-size: 10px;
    color: #999;
    margin-left: auto;
}

/* Tail Bar (above grid) */
.tail-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-bottom: 1px solid #e0e0e0;
    background: #f5f8fa;
    flex-shrink: 0;
}

.tail-bar-label {
    font-size: 11px;
    color: #666;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.tail-bar-divider {
    width: 1px;
    height: 20px;
    background: #d0d0d0;
    margin: 0 4px;
}

.history-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 12px;
    border-bottom: 1px solid #e0e0e0;
    background: #f0f4f8;
    flex-shrink: 0;
}

.history-mode-toggle {
    display: flex;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    overflow: hidden;
}

.toggle-btn {
    padding: 4px 10px;
    font-size: 11px;
    border: none;
    background: #fff;
    color: #555;
    cursor: pointer;
    font-weight: 500;
    transition: background 0.15s, color 0.15s;
}

.toggle-btn + .toggle-btn {
    border-left: 1px solid #d0d0d0;
}

.toggle-btn.active {
    background: #1976d2;
    color: #fff;
}

.toggle-btn:hover:not(.active) {
    background: #f0f0f0;
}

.history-select {
    padding: 4px 6px;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    font-size: 12px;
    background: #fff;
}

.history-status {
    font-size: 11px;
    color: #666;
    white-space: nowrap;
}

.history-instance-select {
    min-width: 210px;
}

.history-time-range {
    display: flex;
    align-items: center;
    gap: 6px;
}

.history-time-range.hidden {
    display: none;
}

.history-datetime {
    padding: 3px 6px;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    font-size: 12px;
    background: #fff;
}

.history-full-hint {
    font-size: 11px;
    color: #666;
    font-style: italic;
    white-space: nowrap;
}

.history-full-hint.hidden {
    display: none;
}

.cache-size {
    font-size: 12px;
    color: #666;
    white-space: nowrap;
}

.tail-duration-input {
    width: 56px;
    padding: 6px 8px;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    font-size: 12px;
    appearance: auto;
    -webkit-appearance: auto;
    -moz-appearance: auto;
}

.tail-duration-input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.message-search-input {
    width: 240px;
    max-width: 36vw;
    padding: 6px 8px;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    font-size: 12px;
}

.message-search-input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

/* Buttons */
.btn {
    padding: 6px 12px;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    font-size: 12px;
    cursor: pointer;
    background: #fff;
    color: #333;
    transition: all 0.2s;
}

.btn:hover {
    background: #f5f5f5;
    border-color: #999;
}

.btn-primary {
    background: #1976d2;
    color: #fff;
    border-color: #1976d2;
}

.btn-primary:hover {
    background: #1565c0;
}

.btn-secondary {
    background: #f0f0f0;
    color: #333;
}

.btn-secondary:hover {
    background: #e0e0e0;
}

#tooltip-toggle-btn.is-active {
    background: #e3f2fd;
    border-color: #90caf9;
    color: #0d47a1;
}

#tooltip-toggle-btn.is-active:hover {
    background: #d7ebfd;
}

.btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.btn-icon {
    padding: 4px 8px;
    min-width: auto;
}

/* Filter List */
.filter-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 3px;
    font-size: 11px;
}

.filter-item input[type="checkbox"] {
    cursor: pointer;
}

.filter-name {
    flex: 1;
    cursor: pointer;
    user-select: none;
}

.filter-type-badge {
    display: inline-block;
    padding: 2px 4px;
    background: #e8eaf6;
    color: #3f51b5;
    border-radius: 2px;
    font-size: 10px;
    font-weight: 500;
}

.filter-delete-btn {
    background: none;
    border: none;
    color: #999;
    cursor: pointer;
    padding: 0 2px;
    font-size: 12px;
}

.filter-delete-btn:hover {
    color: #d32f2f;
}

/* Results Area */
.log-viewer-results {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.results-bar {
    padding: 8px 12px;
    border-bottom: 1px solid #e0e0e0;
    background: #fafafa;
    font-size: 12px;
    color: #666;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.status-bar {
    display: inline-block;
    padding: 2px 6px;
    background: #e3f2fd;
    border-radius: 2px;
    color: #1976d2;
}

.prefetch-progress {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.prefetch-progress-text {
    font-size: 11px;
    color: #4e758e;
}

.prefetch-progress-track {
    width: 100%;
    max-width: 420px;
    height: 8px;
    border-radius: 999px;
    background: #dfe9f1;
    overflow: hidden;
}

.prefetch-progress-fill {
    width: 0%;
    height: 100%;
    background: linear-gradient(90deg, #4c8bb5 0%, #1976d2 100%);
    transition: width 0.2s ease;
}

.slick-container {
    flex: 1;
    overflow: hidden;
}

.hs-log-message-preview {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: help;
}

.log-message-tooltip-popup {
    position: fixed;
    z-index: 5000;
    max-width: min(760px, calc(100vw - 24px));
    max-height: min(70vh, calc(100vh - 24px));
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #2d4a5f;
    background: #10202c;
    color: #e7f2fb;
    box-shadow: 0 10px 30px rgba(8, 17, 24, 0.45);
    pointer-events: auto;
}

.hs-log-tooltip-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.hs-log-tooltip-badge {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    background: #285b87;
    color: #dcefff;
    border-radius: 10px;
    padding: 2px 7px;
}

.hs-log-tooltip-meta {
    font-size: 11px;
    color: #9fc0d8;
}

.hs-log-tooltip-spacer {
    flex: 1;
}

.hs-log-tooltip-btn {
    background: #1d4059;
    border: 1px solid #3e607a;
    color: #d8ebfb;
    border-radius: 4px;
    padding: 3px 8px;
    font-size: 11px;
    cursor: pointer;
}

.hs-log-tooltip-btn:hover {
    background: #295373;
}

.hs-log-tooltip-content {
    margin: 0;
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #30526a;
    background: #0b161f;
    color: #e7f2fb;
    font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;
    font-size: 12px;
    line-height: 1.45;
    white-space: pre-wrap;
    overflow: auto;
    max-height: min(52vh, 480px);
    user-select: text;
}

.hs-log-tooltip-empty {
    color: #9eb9cd;
    font-style: italic;
}

/* Filter Modal */
.filter-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

.filter-modal.hidden {
    display: none;
}

.filter-modal-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
}

.filter-modal-dialog {
    position: relative;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.15);
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    z-index: 2001;
}

.filter-modal-title {
    padding: 16px;
    border-bottom: 1px solid #e0e0e0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.filter-form {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.form-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
}

.form-input {
    padding: 8px 10px;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    font-size: 13px;
    font-family: inherit;
}

.form-input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.form-textarea {
    min-height: 80px;
    resize: vertical;
    font-family: 'Courier New', monospace;
}

.filter-type-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.radio-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
}

.radio-label input[type="radio"] {
    cursor: pointer;
}

.filter-pattern-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 8px;
    margin-bottom: 4px;
}

.filter-type-hint {
    display: block;
    font-size: 11px;
    color: #999;
    font-style: italic;
    margin-top: -8px;
}

.filter-modal-actions {
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    border-top: 1px solid #e0e0e0;
    justify-content: flex-end;
}

/* Utility classes */
.hidden {
    display: none !important;
}

/* Scrollbar Styling */
.log-viewer-sidebar::-webkit-scrollbar,
.slick-container ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.log-viewer-sidebar::-webkit-scrollbar-track,
.slick-container ::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.log-viewer-sidebar::-webkit-scrollbar-thumb,
.slick-container ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.log-viewer-sidebar::-webkit-scrollbar-thumb:hover,
.slick-container ::-webkit-scrollbar-thumb:hover {
    background: #555;
}
`, "",{"version":3,"sources":["webpack://./src/log-viewer.css"],"names":[],"mappings":"AAIA,gCAAgC;;AAEhC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;;;IAGI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,4DAA4D;IAC5D,2BAA2B;AAC/B;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,yCAAyC;IACzC,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,4EAA4E;IAC5E,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB","sourcesContent":["@import url(\"~slickgrid/dist/styles/css/slick.columnpicker.css\");\n@import url(\"~slickgrid/dist/styles/css/slick-alpine-theme.css\");\n@import url(\"./global.css\");\n\n/* Log Viewer Component Styles */\n\n.log-viewer-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n}\n\n.log-viewer-panel {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    z-index: 1001;\n}\n\n.log-viewer-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    border-bottom: 1px solid #e0e0e0;\n    background: #f5f5f5;\n    gap: 12px;\n}\n\n.log-viewer-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.tail-status,\n.tail-timer,\n.log-count {\n    font-size: 12px;\n    color: #666;\n    padding: 4px 8px;\n    background: #e8f5e9;\n    border-radius: 3px;\n}\n\n.tail-timer {\n    background: #fff3e0;\n    color: #f57c00;\n    animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.7; }\n}\n\n.log-count {\n    background: #e3f2fd;\n    color: #1976d2;\n}\n\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-left: auto;\n}\n\n.log-viewer-body {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n}\n\n.log-viewer-sidebar {\n    width: 280px;\n    border-right: 1px solid #e0e0e0;\n    overflow-y: auto;\n    padding: 12px;\n    background: #fafafa;\n}\n\n.sidebar-section {\n    margin-bottom: 20px;\n}\n\n.section-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.section-actions {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.link-btn {\n    background: none;\n    border: none;\n    color: #1976d2;\n    cursor: pointer;\n    font-size: 12px;\n    padding: 2px 4px;\n    border-radius: 2px;\n}\n\n.link-btn:hover {\n    background: #e3f2fd;\n}\n\n#service-refresh-btn {\n    font-size: 18px;\n    line-height: 1;\n    font-weight: 700;\n    padding: 2px 6px;\n}\n\n/* Service Selection */\n.service-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.service-search-input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 6px 8px;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    font-size: 12px;\n    margin-bottom: 6px;\n}\n\n.service-search-input:focus {\n    outline: none;\n    border-color: #1976d2;\n    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);\n}\n\n.service-token-pills,\n.service-token-suggestions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 6px;\n}\n\n.service-token-pills.hidden,\n.service-token-suggestions.hidden {\n    display: none;\n}\n\n.service-token-pill,\n.service-token-suggestion {\n    border: 1px solid #bfd4ea;\n    background: #eef6ff;\n    color: #17456a;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1;\n    padding: 6px 10px;\n    cursor: pointer;\n}\n\n.service-token-suggestion:hover,\n.service-token-pill:hover {\n    background: #e0eefc;\n}\n\n.service-token-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: #dfeeff;\n}\n\n.service-token-pill-remove {\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.service-item {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 6px 10px;\n    background: #fff;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    color: #333;\n    text-align: left;\n    font-family: inherit;\n    transition: background 0.15s, border-color 0.15s;\n}\n\n.service-item:hover {\n    background: #f0f4f8;\n    border-color: #aac4d8;\n}\n\n.service-item.selected {\n    background: #dfeeff;\n    border-color: #6aaad8;\n    color: #0b4e7a;\n    font-weight: 600;\n}\n\n.service-list-empty {\n    font-size: 12px;\n    color: #777;\n    background: #fff;\n    border: 1px dashed #d5d5d5;\n    border-radius: 3px;\n    padding: 8px;\n}\n\n.service-count {\n    font-size: 10px;\n    color: #999;\n    margin-left: auto;\n}\n\n/* Tail Bar (above grid) */\n.tail-bar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    border-bottom: 1px solid #e0e0e0;\n    background: #f5f8fa;\n    flex-shrink: 0;\n}\n\n.tail-bar-label {\n    font-size: 11px;\n    color: #666;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    white-space: nowrap;\n}\n\n.tail-bar-divider {\n    width: 1px;\n    height: 20px;\n    background: #d0d0d0;\n    margin: 0 4px;\n}\n\n.history-bar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 5px 12px;\n    border-bottom: 1px solid #e0e0e0;\n    background: #f0f4f8;\n    flex-shrink: 0;\n}\n\n.history-mode-toggle {\n    display: flex;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    overflow: hidden;\n}\n\n.toggle-btn {\n    padding: 4px 10px;\n    font-size: 11px;\n    border: none;\n    background: #fff;\n    color: #555;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background 0.15s, color 0.15s;\n}\n\n.toggle-btn + .toggle-btn {\n    border-left: 1px solid #d0d0d0;\n}\n\n.toggle-btn.active {\n    background: #1976d2;\n    color: #fff;\n}\n\n.toggle-btn:hover:not(.active) {\n    background: #f0f0f0;\n}\n\n.history-select {\n    padding: 4px 6px;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    font-size: 12px;\n    background: #fff;\n}\n\n.history-status {\n    font-size: 11px;\n    color: #666;\n    white-space: nowrap;\n}\n\n.history-instance-select {\n    min-width: 210px;\n}\n\n.history-time-range {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.history-time-range.hidden {\n    display: none;\n}\n\n.history-datetime {\n    padding: 3px 6px;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    font-size: 12px;\n    background: #fff;\n}\n\n.history-full-hint {\n    font-size: 11px;\n    color: #666;\n    font-style: italic;\n    white-space: nowrap;\n}\n\n.history-full-hint.hidden {\n    display: none;\n}\n\n.cache-size {\n    font-size: 12px;\n    color: #666;\n    white-space: nowrap;\n}\n\n.tail-duration-input {\n    width: 56px;\n    padding: 6px 8px;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    font-size: 12px;\n    appearance: auto;\n    -webkit-appearance: auto;\n    -moz-appearance: auto;\n}\n\n.tail-duration-input:focus {\n    outline: none;\n    border-color: #1976d2;\n    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);\n}\n\n.message-search-input {\n    width: 240px;\n    max-width: 36vw;\n    padding: 6px 8px;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    font-size: 12px;\n}\n\n.message-search-input:focus {\n    outline: none;\n    border-color: #1976d2;\n    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);\n}\n\n/* Buttons */\n.btn {\n    padding: 6px 12px;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    font-size: 12px;\n    cursor: pointer;\n    background: #fff;\n    color: #333;\n    transition: all 0.2s;\n}\n\n.btn:hover {\n    background: #f5f5f5;\n    border-color: #999;\n}\n\n.btn-primary {\n    background: #1976d2;\n    color: #fff;\n    border-color: #1976d2;\n}\n\n.btn-primary:hover {\n    background: #1565c0;\n}\n\n.btn-secondary {\n    background: #f0f0f0;\n    color: #333;\n}\n\n.btn-secondary:hover {\n    background: #e0e0e0;\n}\n\n#tooltip-toggle-btn.is-active {\n    background: #e3f2fd;\n    border-color: #90caf9;\n    color: #0d47a1;\n}\n\n#tooltip-toggle-btn.is-active:hover {\n    background: #d7ebfd;\n}\n\n.btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n.btn-icon {\n    padding: 4px 8px;\n    min-width: auto;\n}\n\n/* Filter List */\n.filter-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.filter-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px;\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 3px;\n    font-size: 11px;\n}\n\n.filter-item input[type=\"checkbox\"] {\n    cursor: pointer;\n}\n\n.filter-name {\n    flex: 1;\n    cursor: pointer;\n    user-select: none;\n}\n\n.filter-type-badge {\n    display: inline-block;\n    padding: 2px 4px;\n    background: #e8eaf6;\n    color: #3f51b5;\n    border-radius: 2px;\n    font-size: 10px;\n    font-weight: 500;\n}\n\n.filter-delete-btn {\n    background: none;\n    border: none;\n    color: #999;\n    cursor: pointer;\n    padding: 0 2px;\n    font-size: 12px;\n}\n\n.filter-delete-btn:hover {\n    color: #d32f2f;\n}\n\n/* Results Area */\n.log-viewer-results {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.results-bar {\n    padding: 8px 12px;\n    border-bottom: 1px solid #e0e0e0;\n    background: #fafafa;\n    font-size: 12px;\n    color: #666;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.status-bar {\n    display: inline-block;\n    padding: 2px 6px;\n    background: #e3f2fd;\n    border-radius: 2px;\n    color: #1976d2;\n}\n\n.prefetch-progress {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.prefetch-progress-text {\n    font-size: 11px;\n    color: #4e758e;\n}\n\n.prefetch-progress-track {\n    width: 100%;\n    max-width: 420px;\n    height: 8px;\n    border-radius: 999px;\n    background: #dfe9f1;\n    overflow: hidden;\n}\n\n.prefetch-progress-fill {\n    width: 0%;\n    height: 100%;\n    background: linear-gradient(90deg, #4c8bb5 0%, #1976d2 100%);\n    transition: width 0.2s ease;\n}\n\n.slick-container {\n    flex: 1;\n    overflow: hidden;\n}\n\n.hs-log-message-preview {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: help;\n}\n\n.log-message-tooltip-popup {\n    position: fixed;\n    z-index: 5000;\n    max-width: min(760px, calc(100vw - 24px));\n    max-height: min(70vh, calc(100vh - 24px));\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid #2d4a5f;\n    background: #10202c;\n    color: #e7f2fb;\n    box-shadow: 0 10px 30px rgba(8, 17, 24, 0.45);\n    pointer-events: auto;\n}\n\n.hs-log-tooltip-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.hs-log-tooltip-badge {\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.3px;\n    text-transform: uppercase;\n    background: #285b87;\n    color: #dcefff;\n    border-radius: 10px;\n    padding: 2px 7px;\n}\n\n.hs-log-tooltip-meta {\n    font-size: 11px;\n    color: #9fc0d8;\n}\n\n.hs-log-tooltip-spacer {\n    flex: 1;\n}\n\n.hs-log-tooltip-btn {\n    background: #1d4059;\n    border: 1px solid #3e607a;\n    color: #d8ebfb;\n    border-radius: 4px;\n    padding: 3px 8px;\n    font-size: 11px;\n    cursor: pointer;\n}\n\n.hs-log-tooltip-btn:hover {\n    background: #295373;\n}\n\n.hs-log-tooltip-content {\n    margin: 0;\n    padding: 10px;\n    border-radius: 6px;\n    border: 1px solid #30526a;\n    background: #0b161f;\n    color: #e7f2fb;\n    font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;\n    font-size: 12px;\n    line-height: 1.45;\n    white-space: pre-wrap;\n    overflow: auto;\n    max-height: min(52vh, 480px);\n    user-select: text;\n}\n\n.hs-log-tooltip-empty {\n    color: #9eb9cd;\n    font-style: italic;\n}\n\n/* Filter Modal */\n.filter-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n}\n\n.filter-modal.hidden {\n    display: none;\n}\n\n.filter-modal-backdrop {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n}\n\n.filter-modal-dialog {\n    position: relative;\n    background: #fff;\n    border-radius: 4px;\n    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.15);\n    width: 90%;\n    max-width: 500px;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    z-index: 2001;\n}\n\n.filter-modal-title {\n    padding: 16px;\n    border-bottom: 1px solid #e0e0e0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.filter-form {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.form-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: #333;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 4px;\n}\n\n.form-input {\n    padding: 8px 10px;\n    border: 1px solid #d0d0d0;\n    border-radius: 3px;\n    font-size: 13px;\n    font-family: inherit;\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: #1976d2;\n    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);\n}\n\n.form-textarea {\n    min-height: 80px;\n    resize: vertical;\n    font-family: 'Courier New', monospace;\n}\n\n.filter-type-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.radio-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.radio-label input[type=\"radio\"] {\n    cursor: pointer;\n}\n\n.filter-pattern-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: #333;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-top: 8px;\n    margin-bottom: 4px;\n}\n\n.filter-type-hint {\n    display: block;\n    font-size: 11px;\n    color: #999;\n    font-style: italic;\n    margin-top: -8px;\n}\n\n.filter-modal-actions {\n    display: flex;\n    gap: 8px;\n    padding: 12px 16px;\n    border-top: 1px solid #e0e0e0;\n    justify-content: flex-end;\n}\n\n/* Utility classes */\n.hidden {\n    display: none !important;\n}\n\n/* Scrollbar Styling */\n.log-viewer-sidebar::-webkit-scrollbar,\n.slick-container ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.log-viewer-sidebar::-webkit-scrollbar-track,\n.slick-container ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.log-viewer-sidebar::-webkit-scrollbar-thumb,\n.slick-container ::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 4px;\n}\n\n.log-viewer-sidebar::-webkit-scrollbar-thumb:hover,\n.slick-container ::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
